import { string } from "prop-types";


export interface ILine {

    Number: string;
    Price: number,
    ProductId: string;
    LineTypeName: string;
    SetupFee: number;
    IvrEnabled: boolean;
    SecretaryEnabled: boolean;
    VoicemailEnabled: boolean;
    FaxEnabled: boolean;
    OutgoingCallEnabled: boolean;
    IsRoundLine: boolean;
    Id: string;
    Errors: string;
    Confirms: string;
    Delete: boolean;
    PageIndex: number;
    PageSize: number;




}

export class Line implements ILine {
    public Number = "";
    public Price = 0;
    public ProductId = "";
    public LineTypeName = "";
    public SetupFee = 0;
    public IvrEnabled = false;
    public SecretaryEnabled = false;
    public VoicemailEnabled = false;
    public FaxEnabled = false;
    public OutgoingCallEnabled = false;
    public IsRoundLine = false;
    public Id = "";
    public Errors = "";
    public Confirms = "";
    public Delete = false;
    public PageIndex = 0;
    public PageSize = 0;
    public lines: ILine[] = []


    constructor(line: any | null) {
        if (line) {
            this.Number = line.Number;
            this.Price = line.Price;
            this.ProductId = line.ProductId;
            this.LineTypeName = line.LineTypeName;
            this.SetupFee = line.SetupFee;
            this.IvrEnabled = line.IvrEnabled;
            this.SecretaryEnabled = line.SecretaryEnabled;
            this.VoicemailEnabled = line.VoicemailEnabled;
            this.FaxEnabled = line.FaxEnabled;
            this.OutgoingCallEnabled = line.OutgoingCallEnabled;
            this.IsRoundLine = line.IsRoundLine;
            this.Id = line.Id;
            this.Errors = line.Errors;
            this.Confirms = line.Confirms;
            this.Delete = line.Delete;
            this.PageIndex = line.PageIndex;
            this.PageSize = line.PageSize;

        }
    }

    createLineList(lineList: any) {
        this.lines = [];
        lineList.forEach((item: any) => {
            let line: ILine = {
                Number: item.Number,
                Price: item.Price,
                ProductId: item.ProductId,
                LineTypeName: item.LineTypeName,
                SetupFee: item.SetupFee,
                IvrEnabled: item.IvrEnabled,
                SecretaryEnabled: item.SecretaryEnabled,
                VoicemailEnabled: item.VoicemailEnabled,
                FaxEnabled: item.FaxEnabled,
                OutgoingCallEnabled: item.OutgoingCallEnabled,
                IsRoundLine: item.IsRoundLine,
                Id: item.Id,
                Errors: item.Errors,
                Confirms: item.Confirms,
                Delete: item.Delete,
                PageIndex: item.PageIndex,
                PageSize: item.PageSize
            }
            this.lines.push(line);
        })
    }
}


export interface ProposedNumber {


    Number: string,
    Price: number,
    ProductId: string,
    LineTypeName: string,
    SetupFee: number,
    IvrEnabled: boolean,
    SecretaryEnabled: boolean,
    VoicemailEnabled: boolean,
    FaxEnabled: boolean,
    OutgoingCallEnabled: boolean,
    IsRoundLine: boolean,
    Id: string,
    Errors: any,
    Confirms: any,
    Delete: boolean,
    PageIndex: number,
    PageSize: number


}

export interface City {

    Name: string,
    Code: string

}



export interface PurchaseState {
    selectPackagePending: boolean;
    selectPackageSuccess: boolean;
    selectPackageError: string | null;
    getCandidateIVRPending: boolean;
    getCandidateIVRSuccess: boolean;
    getCandidateIVRError: string | null;
    getCandidateSecretaryPending: boolean;
    getCandidateSecretarySuccess: boolean;
    getCandidateSecretaryError: string | null;
    getCandidateFaxPending: boolean;
    getCandidateFaxSuccess: boolean;
    getCandidateFaxError: string | null;
    ivrPackages: Package[] | null;
    getProductNumbersCountPending: boolean;
    getProductNumbersCountSuccess: boolean;
    getProductNumbersCountError: string | null;
    packageNumbersCount: number | null | undefined
    secretaryPackages: Package[] | null,
    faxPackages: Package[] | null,
    resultLines: Line[] | null,
    searchFreeProposedNumbersResult: Line[] | null,
    searchFreeProposedNumbersPending: boolean,
    getProposedNumbersResult: ProposedNumber[] | null,
    getProposedNumbersPending: boolean,
    searchProposedNumbersPending: boolean,
    getCitiesResult: City[] | null,
    getProposedNumbersError: string,
    getApplicationContractTypePending: boolean,
    applicationContractType: AppLicationContractType[] | null,
    htmlPreInvoiceToCustomer: any,
    getHtmlPreInvoiceToCustomerPending: boolean,
    gatewayPrepareResult: any,
    postTryReserveRequestedLinesResult: any,
    postTryReserveRequestedLinesPending: boolean,
    getHtmlPreInvoiceToCustomerError: any,
    postPurchaseBuySuccess: boolean,
    purchaseInfo: any,
    postPurchaseBuyError: string,
    getPurchaseInfoPending: boolean,
    postPurchaseBuyPending: boolean,
    getPurchaseInfoResult: any,
    genHtmlPINRCResult: any,
    genHtmlPINRCPending: boolean,
    genHtmlPINRCError: any

}

export interface Package {

    ProductId: string;
    Name: string;
    MonthlyCharge: number;
    GiftCredit: number;
    Minutes: number;
    LineCount: number;
    ExtraMinuteCost: number;
    IsExtendEnabled: boolean;
    IsDowngradeEnabled: boolean;
    IsUpgradeEnabled: boolean;
    IsNewPurchaseEnabled: boolean;
    IsExtendMonthlyCharge: boolean;
    IsVisible: boolean;
    LinePrefixes: string[];
    SixMonthsCharge: number;
    AnnuallyCharge: number;
    AnnuallyDiscount: number;
    SixMonthsDiscount: number;


}





export interface SelectPackageSuccessPayload {

}

export interface ErrorPayLoad {
    error: string

}


export interface SelectCandidatePayLoad {
    productId: string,
    prefixedLineType: number | null,
    number: string | null

}

export interface SelectByProductIdPayLoad {
    productId: string,


}

export interface AppLicationContractType {
    DiscountPercent: number;
    DurationDays: number;
    Id: string;
    Title: string
}


export interface GetHtmlPreInvoicePayload {
    ProductType: number,
    ProductId: string,
    ContractTypeId: number,
    LineIds: string[],
    // AdditionalLineIds: string[],
    DiscountCode: string
}



export interface IDefaultGateway {
    GatewayId: string,
    Name: string,
    Caption: string
}
export interface IHtmlPreInvoice {
    InvoiceId: string,
    Amount: number,
    HTMLContent: string,
    PaymentGatewayList: IDefaultGateway[],
    DefaultGateway: IDefaultGateway
}

export class HtmlPreInvoice implements IHtmlPreInvoice {
    public InvoiceId = ''
    public Amount = 0
    public HTMLContent = ''
    public DefaultGateway = {
        GatewayId: '',
        Name: '',
        Caption: ''
    }
    public PaymentGatewayList: IDefaultGateway[] = []


    constructor(htmlPreInvoice: any | null) {
        if (htmlPreInvoice) {
            this.InvoiceId = htmlPreInvoice.invoiceId
            this.Amount = htmlPreInvoice.amount
            this.HTMLContent = htmlPreInvoice.htmlContent
            htmlPreInvoice?.paymentGatewayList?.map((item: any) => {
                this.PaymentGatewayList.push({
                    GatewayId: item?.gatewayId,
                    Name: item?.name,
                    Caption: item?.caption
                }
                )
            })
            this.DefaultGateway = {
                GatewayId: htmlPreInvoice.defaultGateway?.gatewayId,
                Name: htmlPreInvoice.defaultGateway?.name,
                Caption: htmlPreInvoice.defaultGateway?.caption
            }
        }
    }
}


export interface ILineNumber {

    id: string,
    color: string,
    number: string,
    callType: string,
    lineStartDate: string | null,
    lineExpireDate: string,
    packageStartDate: string | null,
    packageExpireDate: string | null,
    lineRemainingAmount: number,
    packageRemainingAmount: number,
    title: string,
    isExtensionTime: boolean,
    lineId: string,
    productId: string,
    enabled: boolean,
    lineServiceType: number,
    lineRemainingDays: number,
    typeOfProductPurchasedWith: string

}